export default {
	recaptcha: {
		siteKey: '6LfvuJQUAAAAAKAc-lo6oqB2LklNSTw3WpC_jK9i',
		secretKey: '6LfvuJQUAAAAAIAW-nKIQtuEwbEMF06swD9Oreqr',
	},
	apiKey: '6LfvuJQUAAAAAIAW-nKIQtuEwbEMF06swD9Oreqr',
};
